/* eslint-disable */

import axios from 'axios'

const SERVICE = "/files";

export default {
    save: ({commit}, payload) => {
        if (payload.url) {
            if (payload.id > 0) {
                return axios.put(SERVICE + "/" + payload.id, payload)
                    .then(resp => resp.data)
            } else {
                return axios.post(SERVICE, payload)
                    .then(resp => resp.data)
            }
        } else {
            return Promise.resolve({});
        }
    },
}